var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#check-large';
                    var viewUrl = 'svg/global.svg#view-check-large';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 25',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };